import "./QuestionComponent.css";

const MultipleChoice = ({ question, setAnswer, answer }) => {

  return (
    <div className="answers-container">
      {question.esFalsoVerdadero === "true" ? (
        <>
          <button className="Button"
            onClick={() => setAnswer("true")}
            disabled={answer === "true"}>
            <div>
               Verdadero
            </div>
          </button>

          <button className="Button"
            onClick={() => setAnswer("false")}
            disabled={answer === "false"}>
            <div>
               Falso
            </div>
          </button>
        </>
      ) : (
        question.respuestas.map((option, index) => (
          <button className="contBtnAnswer"
            onClick={() => setAnswer(index)}
            disabled={answer === index}>
            <div className="btnAnswer">
            {option}
            </div>
          </button>
        ))
      )}
    </div>
  )
}

export default MultipleChoice;